import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';
import { BiChevronRight, BiLogoChrome, BiServer, BiSearchAlt, BiLogoVisualStudio } from "react-icons/bi";

const ItConsultingWeitereDienstleistungen = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('itConsulting_moreServices_subtitle')}</span>
            <h2>{t('itConsulting_moreServices_title')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">

                <div className="col-sm-6">
                  <Link href="/business-analytics" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiSearchAlt />
                      </div>
                      <h3>{t('itConsulting_moreServices_businessAnalytics_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('itConsulting_moreServices_businessAnalytics_description') }} />
                      <span className="features-box-action">{t('itConsulting_moreServices_businessAnalytics_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiSearchAlt />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/kuenstliche-intelligenz/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiServer />
                      </div>
                      <h3>{t('itConsulting_moreServices_artificialIntelligence_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('itConsulting_moreServices_artificialIntelligence_description') }} />
                      <span className="features-box-action">{t('itConsulting_moreServices_artificialIntelligence_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiServer />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('itConsulting_moreServices_webDevelopment_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('itConsulting_moreServices_webDevelopment_description') }} />
                      <span className="features-box-action">{t('itConsulting_moreServices_webDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/software-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoVisualStudio />
                      </div>
                      <h3>{t('itConsulting_moreServices_softwareDevelopment_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('itConsulting_moreServices_softwareDevelopment_description') }} />

                      <span className="features-box-action">{t('itConsulting_moreServices_softwareDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoVisualStudio />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>

        </div>
      </div>
    </>
  );
};

export default ItConsultingWeitereDienstleistungen;
